var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enter poc perspective",style:(_vm.enterStyle)},[_vm._l((_vm.items),function(item){return [(_vm.show[item['id']])?_c(item['name'],{tag:"component",attrs:{"mode":_vm.enter[item['id']]}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }